import React, { useRef, useEffect } from 'react';
import WalletChecker from './components/WalletChecker';
import './App.css';

const backgroundStyle = {
  backgroundImage: `url(${process.env.PUBLIC_URL}/background.jpg)`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundAttachment: 'fixed',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
};

function App() {
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = audioRef.current;

    if (audio) {
      audio.muted = true;
      audio.play().catch((err) => {
        console.log('자동 재생 실패 (정상): 사용자 입력 필요');
      });

      // 사용자 상호작용 발생 시 소리 켜기
      const enableAudio = () => {
        if (audio) {
          audio.muted = false;
          audio.play().catch(() => {});
        }
        window.removeEventListener('click', enableAudio);
        window.removeEventListener('touchstart', enableAudio);
        window.removeEventListener('keydown', enableAudio);
      };

      window.addEventListener('click', enableAudio);
      window.addEventListener('touchstart', enableAudio);
      window.addEventListener('keydown', enableAudio);
    }
  }, []);

  return (
    <div style={backgroundStyle}>
      <audio ref={audioRef} src="/bgm.mp3" autoPlay loop />
      <WalletChecker />
    </div>
  );
}

export default App;






